
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uber-den-titel",
      function () {
        return require("private-next-pages/uber-den-titel.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uber-den-titel"])
      });
    }
  